'use strict';
const angular = require('angular');
const {isFunction, isObject, noop} = angular;

module.exports = [
  '$provide',
  filterInputDirectiveDecorator];

// TODO: implement standard API in front of ionic service
function filterInputDirectiveDecorator($provide) {
  $provide.decorator('filterInputDirective', ['$delegate', '$log', '$timeout', '$ionicPlatform', decorateDirective]);

  function decorateDirective($delegate, $log, $timeout, $ionicPlatform) {
    var directive = $delegate[0];
    var compile = directive.compile || noop;

    directive.compile = function () {
      var compiled = compile.apply(this, arguments);
      var pre, post;

      if (isFunction(compiled)) {
        post = compiled;
      } else if (isObject(compiled)) {
        pre = compiled.pre;
        post = compiled.post;
      }

      // decorate post
      var decoratedPost = function decoratedPost($scope, $element, $attrs) {
        post && post.apply(this, arguments);

        var input = $element.find('input');

        if (!input[0]) {
          $log.warn('filterInputDirective: could not find filter input element!');
        } else {
          input = input[0];
          var deregister = $ionicPlatform.on('searchbutton', onSearch);

          $scope.$on('$destroy', deregister);
        }

        function onSearch() {
          $timeout(input.focus.bind(input));
        }
      };

      return {
        pre: pre,
        post: decoratedPost
      }
    };

    return $delegate;
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/filters/FilterInputDirectiveDecorator.js